import script from "./ProductStats.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductStats.vue?vue&type=script&lang=ts&setup=true"

import "./ProductStats.vue?vue&type=style&index=0&id=0e8e9279&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e8e9279"]])

export default __exports__